import { GRAPHQL_ENDPOINT } from "../apollo/client";
import { useEffect } from "react";
import { logout } from "../apollo/logout";


export default function LogoutPage() {

    useEffect(() => {
        async function performLogout() {
            try {
                // Use the proper logout function to clean up
                await logout();
                // Redirect to login page
                window.location.href = '/auth';
            } catch (error) {
                console.error('Error during logout:', error);
                // Fallback - if logout fails, force redirect
                window.location.href = '/auth';
            }
        }
        performLogout();
    }, []);

    return (
        <div className="container mx-auto my-auto p-6 ">
            <p>
                Sie werden nun abgemeldet. Sie werden in Kürze zur Anmeldeseite weitergeleitet.
            </p>
        </div>
    );
}